import React from 'react';
import {useFormikContext} from 'formik';
import {JobEntry} from 'src/views/admin/ScheduledJobs/types';
import FormikDropdown from 'src/components/formik-dropdown';
import FieldComponent from 'src/components/FieldComponent';
import {FormOption} from 'src/types/form';

export const WEEKDAY_OPTIONS = [
  {_id: '1', value: '1', text: 'Sunday'},
  {_id: '2', value: '2', text: 'Monday'},
  {_id: '3', value: '3', text: 'Tuesday'},
  {_id: '4', value: '4', text: 'Wednesday'},
  {_id: '5', value: '5', text: 'Thursday'},
  {_id: '6', value: '6', text: 'Friday'},
  {_id: '7', value: '7', text: 'Saturday'},
];

const generateOptions = (type: 'minute' | 'hour' | 'dayMo'): FormOption[] => {
  const options: FormOption[] = [];
  switch (type) {
    case 'hour':
      for (let i = 0; i < 24; i++) {
        const value = i + '';
        options.push({_id: value, value, text: value.length < 2 ? `0${value}` : value});
      }
      break;
    case 'minute':
      for (let i = 0; i < 60; i++) {
        const value = i + '';
        options.push({_id: value, value, text: value.length < 2 ? `0${value}` : value});
      }
      break;
    case 'dayMo':
      for (let i = 0; i < 29; i++) {
        const value = i + '';
        options.push({_id: value, value, text: value});
      }
      break;
  }

  return options;
};

export const ScheduleSelector = (): React.ReactElement => {
  const form = useFormikContext<JobEntry>();

  return (
    <>
      <FormikDropdown
        placeholder="Schedule Type"
        name="scheduleType"
        options={[
          {_id: 'MINUTE', value: 'MINUTE', text: 'Every n minutes'},
          {_id: 'DAILY', value: 'DAILY', text: 'Daily'},
          {_id: 'WEEKLY', value: 'WEEKLY', text: 'Weekly'},
          {_id: 'MONTHLY', value: 'MONTHLY', text: 'Monthly'},
        ]}
      />
      {form.values.scheduleType === 'MINUTE' && (
        <FieldComponent type="number" name="min" withLabel={false} />
      )}
      {form.values.scheduleType === 'DAILY' && (
        <>
          <FormikDropdown placeholder="Hour" name="hour" options={generateOptions('hour')} />
          <FormikDropdown name="min" placeholder="Minute" options={generateOptions('minute')} />
        </>
      )}
      {form.values.scheduleType === 'WEEKLY' && (
        <>
          <FormikDropdown placeholder="Week day" name="wd" options={WEEKDAY_OPTIONS} />
          <FormikDropdown name="hour" placeholder="Hour" options={generateOptions('hour')} />
          <FormikDropdown name="min" placeholder="Minute" options={generateOptions('minute')} />
        </>
      )}
      {form.values.scheduleType === 'MONTHLY' && (
        <>
          <FormikDropdown name="dayMo" placeholder="Month day" options={generateOptions('dayMo')} />
          <FormikDropdown placeholder="Hour" name="hour" options={generateOptions('hour')} />
          <FormikDropdown name="min" placeholder="Minute" options={generateOptions('minute')} />
        </>
      )}
    </>
  );
};
